import { render } from "./CampaignsDetailInformationSkeletons.vue?vue&type=template&id=92eb312c"
import script from "./CampaignsDetailInformationSkeletons.vue?vue&type=script&lang=js"
export * from "./CampaignsDetailInformationSkeletons.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__